import { Button, FlexBox, Text } from '@fable/components'
import { useDeviceDetect } from '@fable/hooks'
import { css, useTheme } from '@fable/theme'
import { AppDownloadAnchorLink } from 'app/marketing/components/AppDownloadAnchorLink'
import { SharePageQR } from 'app/social/pages/share_page/SharePageQR'

interface Props {
  button?: {
    title: string
    onClick: () => void
  }
}

export const DownloadAppQRCallout = ({ button }: Props) => {
  const { colors, mediaQueries } = useTheme()
  const { isMobile } = useDeviceDetect()

  const getCta = () => {
    if (!!button) {
      return <Button onClick={button.onClick}>{button.title}</Button>
    }
    if (isMobile) {
      return (
        <AppDownloadAnchorLink anchor={{ id: 'download-app', offset: 160 }} />
      )
    }
    return (
      <SharePageQR
        className={css`
          margin: 0 auto;
          z-index: 0;
        `}
        hideOnMobileLayout={false}
      />
    )
  }

  return (
    <FlexBox
      id="download-app"
      className={css`
        margin: 40px auto 0;
        max-width: 352px;
      `}
      flexDirection="column"
      gap="20px"
      centerAll
    >
      <Text
        className={css`
          max-width: 220px;
          ${mediaQueries.mobileL} {
            max-width: 280px;
          }
        `}
        type="body"
        sizing={{ base: 'M', mobileL: 'XL' }}
        color={colors.uiGraphite}
        align="center"
      >
        {isMobile
          ? 'Download the free app to get started today!'
          : 'Scan the QR code to download the app to get started today!'}
      </Text>
      {getCta()}
    </FlexBox>
  )
}
